/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import get_token from "../lib/get_token";
import CouponSearch from "./CouponSearch";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onClosePop } = props;
  const token = get_token();
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const [sdate, setSdate] = useState(moment().format("YYYY-MM-DD"));
  const [edate, setEdate] = useState(
    moment().add(1, "month").format("YYYY-MM-DD")
  );
  const [tmcd, setTmcd] = useState("");
  const [pid, setPid] = useState("");
  const [method, setMethod] = useState("");
  const [name, setName] = useState(""); //*
  const [gubun, setGubun] = useState(""); //*
  const [rate, setRate] = useState(""); //*
  const [amount, setAmount] = useState(0); //*
  const [minPrice, setMinPrice] = useState(0); //*
  const [maxPrice, setMaxPrice] = useState(0); //*
  const [days, setDays] = useState(0); //*

  const onSubmit = async () => {
    const postData = {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      tmcd: tmcd,
      dcoupon_id: coupon,
      sdate: sdate,
      edate: edate,
      name: scoupon,
    };
    let result = await axios.post(
      configState.api + "/gympass_admin/dcoupon_issue_add",
      postData
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }
  };

  // MemberSearch
  const [sname, setSname] = useState("");
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };
  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };
  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setSname(name);
    setTmcd(id);
  };

  // CouponSearch
  const [coupon, setCoupon] = useState("");
  const [scoupon, setScoupon] = useState("");
  const [showCouponSearch, setShowCouponSearch] = useState(false);
  const onShowCouponSearchClick = () => {
    setShowCouponSearch(true);
  };
  const onHideCouponSearchClick = () => {
    setShowCouponSearch(false);
  };
  const onAfterCouponSearchClick = (params) => {
    const { id, name, day } = params;
    setScoupon(name);
    setCoupon(id);
    setEdate(moment(sdate).add(day, "day").format("YYYY-MM-DD"));
  };

  return (
    <Box>
      {/* 사용자 찾기 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          login={login}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      {/* 쿠폰 찾기 */}
      <Dialog
        open={showCouponSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>할인쿠폰 찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideCouponSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <CouponSearch
          login={login}
          onAfterSearchClick={onAfterCouponSearchClick}
          onHideSearchClick={onHideCouponSearchClick}
        />
      </Dialog>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        {/* 센터명 */}
        <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={sname}
          ></TextField>

          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowMemberSearchClick}
          >
            조회
          </Button>
        </Box>

        {/* 쿠폰명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="scoupon"
            label="쿠폰명"
            size="small"
            sx={{
              width: "300px",
            }}
            autoComplete="off"
            value={scoupon}
          ></TextField>

          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowCouponSearchClick}
          >
            조회
          </Button>
        </Box>

        {/* 시작일 */}
        <Box sx={{ display: "flex", mt: 1 }}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <MobileDatePicker
                allowSameDateSelection={true}
                value={sdate}
                label="시작일"
                renderInput={(params) => <TextField {...params} />}
                onChange={(newDate) =>
                  setSdate(moment(newDate).format("YYYY-MM-DD"))
                }
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ ml: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <MobileDatePicker
                name="edate"
                allowSameDateSelection={true}
                value={edate}
                label="종료일"
                renderInput={(params) => <TextField {...params} />}
                onChange={(newDate) =>
                  setEdate(moment(newDate).format("YYYY-MM-DD"))
                }
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box>
        </Box>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;
